import React from 'react'
import { useI18n } from '../../../i18n'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

type State = 'NONE' | 'PARTIAL' | 'SUFFICIENT' | 'STALE' | 'CONFLICTED'

const TONE_CLASS: Record<State, string> = {
  NONE: listStyles.sufficiencyNone,
  PARTIAL: listStyles.sufficiencyPartial,
  SUFFICIENT: listStyles.sufficiencySufficient,
  STALE: listStyles.sufficiencyStale,
  CONFLICTED: listStyles.sufficiencyConflicted,
}

interface Props {
  state?: State | string | null
  reason?: string | null
}

export function EvidenceSufficiencyIndicator({ state, reason }: Props) {
  const { t } = useI18n()
  const s = (String(state || 'NONE').toUpperCase() as State) || 'NONE'
  const label = t(`complianceEvidence.sufficiency.${s}`, s)
  const tone = TONE_CLASS[s] || TONE_CLASS.NONE

  return (
    <span
      className={`${listStyles.sufficiencyBadge} ${tone}`}
      title={reason || undefined}
    >
      {t('complianceEvidence.sufficiency.label', 'Evidence')}: {label}
    </span>
  )
}
